
import APIClient from './APIClient'

class CAuthAPI {

  async login({email, password}) {
    const res = await APIClient.POST('/auth/login', { email, password })
    return res
  }

  async forgotPassword({email}) {
    return await APIClient.POST('/auth/forgotPassword', { email })
  }

  async resetPassword({token, password, password_confirmation}) {
    return await APIClient.POST('/auth/resetPassword', {token, password, password_confirmation})
  }
}

const AuthAPI = new CAuthAPI()

export default AuthAPI



// WEBPACK FOOTER //
// ./src/api/AuthAPI.js